const footerData = [
  {
    text: 'Hughesnet Availability',
    href: '/',
    subnav: [
      {
        text: '',
        href: '',
      },
    ],
  },
  {
    text: 'Terms of Use',
    href: 'https://legal.hughesnet.com/TermsOfUse.cfm',
    subnav: [
      {
        text: 'Subscriber Policies',
        href: 'https://legal.hughesnet.com/SubscriberPolicies.cfm',
      },
    ],
  },
]

export default footerData
